import React from "react";
import { Paper, Box } from "@mui/material";

import TabPanel from "components/ApiTabPanel/ApiTabPanel";
import CodeCard from "components/shared/CodeCard.js";
import ApiAttribute from "components/ApiAttribute/ApiAttribute";
import {
  BOM_ATTRIBUTES,
  BOM_JSON,
} from "views/ApiDoc/ApiSections/Item/constants";

export function ItemOtherTab(props) {
  const { value, childAttributes } = props;

  return (
    <TabPanel value={value} index={6}>
      <Box style={{ width: "58%" }}>
        <h3>BOM query</h3>
        <p>
          This returns an array of the Bill of Material for an item, if the item
          is an assembly or kit.
        </p>
        <p>
          <em>This is currently in Beta and could change in the future.</em>
        </p>
        <CodeCard>GET /api/v2/item/:id/bom</CodeCard>
        <p>Example:</p>
        <CodeCard>GET /api/v2/item/123/bom</CodeCard>
        <p style={{ fontWeight: 400 }}>Attributes</p>
        {BOM_ATTRIBUTES.map((attribute) => (
          <ApiAttribute
            key={attribute.name}
            name={attribute.name}
            type={attribute.type}
            description={attribute.description}
            readOnly={attribute.readOnly}
          />
        ))}
        {childAttributes && childAttributes.length > 0 && (
          <React.Fragment>
            <hr />
            <h3>BOM line item object</h3>
            {childAttributes.map((attribute) => (
              <ApiAttribute
                key={attribute.name}
                name={attribute.name}
                type={attribute.type}
                description={attribute.description}
                readOnly={attribute.readOnly}
              />
            ))}
          </React.Fragment>
        )}
      </Box>
      <Box style={{ width: "9%" }} />
      <Box style={{ width: "33%" }} className="example-json">
        <Paper>
          <div className="title">
            <div className="method-example-response-title">Example JSON</div>
          </div>
          <hr />
          <div className="json-content">
            <pre>
              <code>{BOM_JSON}</code>
            </pre>
          </div>
        </Paper>
      </Box>
    </TabPanel>
  );
}
